module.exports = __webpack_public_path__ + "static/img/4.2b46ac4.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/management/4.png
// module id = P5ln
// module chunks = 7